export default function findByKeyValue(object, key, value) {
    if (!object || typeof object !== 'object') {
        return null
    }

    if (
        Object.prototype.hasOwnProperty.call(object, key) &&
        object[key] === value
    ) {
        return object
    }

    for (let i = 0; i < Object.keys(object).length; i++) {
        const o = findByKeyValue(object[Object.keys(object)[i]], key, value)
        if (o != null) {
            return o
        }
    }

    return null
}
